import React from 'react';

import { IconProps } from '@shared/ui/Icon/model/types';

export const InventoryCopyIcon = ({
    fill = 'currentColor',
    width = 12,
    height = 12,
}: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1 0C0.4475 0 0 0.4475 0 1V7.5C0 7.77614 0.223858 8 0.5 8C0.776142 8 1 7.77614 1 7.5V1H7.5C7.77614 1 8 0.776142 8 0.5C8 0.223858 7.77614 0 7.5 0H1ZM3 2C2.4475 2 2 2.4475 2 3V9C2 9.5525 2.4475 10 3 10H9C9.5525 10 10 9.5525 10 9V3C10 2.4475 9.5525 2 9 2H3ZM3 3H9V9H3V3Z"
            fill={fill}
        />
    </svg>
);
